import React, { useState } from "react";
import OTPInput from "react-otp-input";
import ResendMobileOTP from "./ResendOtp/ResendMobileOtp";
import { Spinner } from "reactstrap";
import { CustomSnackbar } from "../CustomSnackbar";
import { apiErrorHandler } from "../common";
import { verifyMobileOtp } from "../../api/customer";
import PropTypes from "prop-types";

const VerifyMobile = ({
  formData,
  onVerifyMobileSuccess,
}) => {
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleVerifyMobile = async () => {
    if (!otp) {
      CustomSnackbar.error("Please enter OTP!");
      return;
    }

    if (otp?.length < 6) {
      CustomSnackbar.error("Invalid OTP!");
      return;
    }

    if (isLoading) {
      return; // Prevent multiple submissions
    }

    setIsLoading(true);
    try {
      const payload = {
        mobile_number: formData?.mobile_number,
        mobile_verification_otp: otp,
      };

      const response = await verifyMobileOtp(payload);

      if (response?.data?.token) {
        if (onVerifyMobileSuccess) {
          onVerifyMobileSuccess();
        }
      }
    } catch (error) {
      apiErrorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='w-100 verification-container'>
      <div className='verification-card'>
        <div className='text-center mb-4'>
          <h4 className='verification-title'>Verify Mobile Number</h4>
          <p className='verification-subtitle'>
            An OTP has been sent to your mobile number <b>{formData?.mobile_number}</b>.
            Please verify your mobile number to continue.
          </p>
        </div>

        <div className="otp-container">
          <OTPInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={<span style={{ margin: 4 }}>-</span>}
            containerStyle={{ 
              display: "flex", 
              justifyContent: "center", 
              alignItems: "center", 
              flexWrap: "nowrap",
              gap: "3px",
              marginBottom: "15px",
              padding: "0 5px",
              maxWidth: "100%"
            }}
            inputType='number'
            renderInput={(props) => (
              <input
                {...props}
                className={`otp-input`}
                style={{ flexShrink: 0 }}
              />
            )}
          />
        </div>

        <div className='resend-otp-container'>
          <ResendMobileOTP mobile_number={formData?.mobile_number} maxTime={60} />
        </div>

        <div className='text-center mt-4'>
          {isLoading ? (
            <button
              className='verify-btn w-50 disabled'
              type='button'
              disabled
            >
              <Spinner size="sm" className="me-2" />
              Verify Mobile
            </button>
          ) : (
            <button
              className='verify-btn w-50'
              type='button'
              onClick={handleVerifyMobile}
            >
              Verify Mobile
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

VerifyMobile.propTypes = {
  formData: PropTypes.object,
  onVerifyMobileSuccess: PropTypes.func,
};

export default VerifyMobile; 